import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import * as partnerService from '../../../../data-layer/partner/service';
import { bikRegExp } from '../../../../utils/regexps';

export const useBankData = () => {
    const handleBikChange = useCallback(
        async (bik: string, bankNameOnChange?: (value: string) => void) => {
            bankNameOnChange?.('');

            if (!bikRegExp.test(bik)) {
                return;
            }

            try {
                const { data } = await partnerService.getBankInfoByBic(bik);
                bankNameOnChange?.(data.name || '');
            } catch (error) {
                bankNameOnChange?.('');
            }
        },
        [],
    );

    return {
        handleBikChange,
    };
};
